import { Users as HeaderIcon } from 'lucide-react'
import { AdminHeader } from '@components/layout/admin-header'
// import { Button } from '@components/v2/button'
import { DateFilter } from '@components/v2/dateFilter'
import { UserActivityLogTable } from './components/activities-table'
import { t } from '@lingui/core/macro'

export const UserActivityLog = () => (
  <div>
    <AdminHeader>
      <div className="flex flex-row justify-between w-full">
        <div className="flex flex-row">
          <AdminHeader.PageIcon>
            <HeaderIcon color="hsla(194, 47%, 20%, 1)" size={28} />
          </AdminHeader.PageIcon>
          <div className="ml-4">
            <AdminHeader.Title>{t`User activity log`}</AdminHeader.Title>
            <AdminHeader.Subtitle>
              {t`See all activities/operations performed by users, managers and admins`}
            </AdminHeader.Subtitle>
          </div>
        </div>
        {/* TODO: target this in AG-86 ticket */}
        {/* <div className="self-end pr-16"> */}
        {/*  <Button variant="outline" className="font-normal"> */}
        {/*    Export */}
        {/*  </Button> */}
        {/* </div> */}
      </div>
    </AdminHeader>
    <div className="px-16 py-8 flex flex-col">
      <div className="mb-4 flex flex-row [&_button]:shadow-none [&_button]:border-[#30505A]">
        <DateFilter />
      </div>
      <UserActivityLogTable />
    </div>
  </div>
)
